<template>
    <nav v-if="pages > 1" class="mt-16">
        <ul class="pagination">
            <li class="pagination__item">
                <button
                    rel="prev"
                    class="pagination__button"
                    :disabled="current <= 1"
                    @click.prevent="$emit('changed', current - 1)"
                >
                    <span>&lt;</span>
                </button>
            </li>

            <li v-for="n in prevPages" :key="n" class="pagination__item">
                <button
                    rel="prev"
                    class="pagination__button"
                    :disabled="current === n"
                    @click.prevent="$emit('changed', n)"
                >
                    <span>{{ n }}</span>
                </button>
            </li>

            <li class="pagination__item pagination__item--current">
                <button
                    rel="prev"
                    class="pagination__button"
                    disabled
                    @click.prevent="$emit('changed', current)"
                >
                    <span>{{ current }}</span>
                </button>
            </li>

            <li v-for="n in nextPages" :key="n" class="pagination__item">
                <button
                    rel="prev"
                    class="pagination__button"
                    :disabled="current === n"
                    @click.prevent="$emit('changed', n)"
                >
                    <span>{{ n }}</span>
                </button>
            </li>

            <li class="pagination__item">
                <button
                    rel="prev"
                    class="pagination__button"
                    :disabled="current >= pages"
                    @click.prevent="$emit('changed', current + 1)"
                >
                    <span>&gt;</span>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        items: {
            type: Number,
            required: true,
        },
        itemsPerPage: {
            type: Number,
            required: true,
        },
        current: {
            type: Number,
            required: true,
        },
    },

    emits: ['changed'],

    computed: {
        pages() {
            return Math.ceil(this.items / this.itemsPerPage);
        },
        prevPages() {
            const total = Math.max(this.current - 1, 0);
            const array = [];

            for (let i = 0; i < Math.min(total, 1); ++i) {
                array.push(1 + i);
            }

            for (let i = Math.max(this.current - 2, 1); i < this.current; ++i) {
                if (array.indexOf(i) === -1) {
                    array.push(i);
                }
            }

            return array;
        },
        nextPages() {
            const total = this.pages - this.current;
            const array = [];

            for (let i = 0; i < Math.min(total, 1); ++i) {
                array.unshift(this.pages - i);
            }

            for (let i = this.current + 2; i > this.current; --i) {
                if (i <= this.pages && array.indexOf(i) === -1) {
                    array.unshift(i);
                }
            }

            return array;
        },
    },
};
</script>
